import React from "react";

const useModal = () => {
  const [modal, setModal] = React.useState(false);
  const openModal = React.useCallback(() => {
    setModal(true);
  }, [setModal]);
  const closeModal = React.useCallback(() => {
    setModal(false);
  }, [setModal]);
  return { modal, openModal, closeModal };
};

export const useModals = <K extends string>() => {
  const [modal, setModal] = React.useState<K>();
  const openModal = React.useCallback(
    (modalType: K) => {
      setModal(modalType);
    },
    [setModal],
  );
  const closeModal = React.useCallback(() => {
    setModal(undefined);
  }, [setModal]);
  return { modal, openModal, closeModal };
};

export default useModal;
